import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_entitlement_auto_top_up_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  template_guid: fromDatatype.GuidDataFieldInterface;
  run_guid: fromDatatype.GuidDataFieldInterface;
  entitlement_hdr_guid: fromDatatype.GuidDataFieldInterface;
  recurring_group_guid_01: fromDatatype.GuidDataFieldInterface;
  recurring_group_guid_02: fromDatatype.GuidDataFieldInterface;
  recurring_event_params: fromDatatype.VarcharDatatypeInterface;
  is_recurring: boolean;
  rrule: fromDatatype.VarcharDatatypeInterface;
  recurring_update_type: fromDatatype.VarcharDatatypeInterface;
  recurring_posting_status: fromDatatype.VarcharDatatypeInterface;
  recurring_posting_error: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  visibility_setting: fromDatatype.VarcharDatatypeInterface;
  duration_day: fromDatatype.BigIntegerDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_entitlement_auto_top_up_event_RowClass implements
  bl_aat_entitlement_auto_top_up_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  template_guid: fromDatatype.GuidDataFieldInterface;
  run_guid: fromDatatype.GuidDataFieldInterface;
  entitlement_hdr_guid: fromDatatype.GuidDataFieldInterface;
  recurring_group_guid_01: fromDatatype.GuidDataFieldInterface;
  recurring_group_guid_02: fromDatatype.GuidDataFieldInterface;
  recurring_event_params: fromDatatype.VarcharDatatypeInterface;
  is_recurring: boolean;
  rrule: fromDatatype.VarcharDatatypeInterface;
  recurring_update_type: fromDatatype.VarcharDatatypeInterface;
  recurring_posting_status: fromDatatype.VarcharDatatypeInterface;
  recurring_posting_error: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  visibility_setting: fromDatatype.VarcharDatatypeInterface;
  duration_day: fromDatatype.BigIntegerDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
